<template>
  <div class="home">
    <!-- Loading组件 -->
    <go-loading-b v-show="isLoading"></go-loading-b>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      isLoading: true,
    }
  }
}
</script>

<style scoped>
.home {
  display: flex;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
}
</style>
